import { finalPageData } from '../../content/finalPageData';
import { analyticsGoals, trackAnalyticsGoal } from '../../lib/analytics/yandexMetrika';
import { BrandLogo } from '../brand-logo/BrandLogo';
import styles from './SiteFooter.module.scss';

export function SiteFooter() {
  const { contacts, footerNavigation } = finalPageData;
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.main}>
        <div className={styles.brandBlock}>
          <a className={styles.brand} href="#top" aria-label="Лучезарная Долина, к началу страницы">
            <BrandLogo className={styles.logo} />
          </a>
          <p>Коттеджный посёлок в Ломоносовском районе Ленинградской области</p>
        </div>

        <nav className={styles.navigation} aria-label="Навигация в подвале страницы">
          {footerNavigation.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={
                item.href === '#purchase'
                  ? () => trackAnalyticsGoal(analyticsGoals.purchaseTermsClick)
                  : undefined
              }
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className={styles.contacts}>
          <p className={styles.columnLabel}>Связаться</p>
          {contacts.telegram ? (
            <a
              href={contacts.telegram.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${contacts.telegram.label}, откроется в новой вкладке`}
              onClick={() => trackAnalyticsGoal(analyticsGoals.telegramClick)}
            >
              Telegram
            </a>
          ) : null}
          {contacts.max ? (
            <a
              href={contacts.max.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${contacts.max.label}, откроется в новой вкладке`}
            >
              MAX
            </a>
          ) : null}
          {contacts.phone ? <a href={contacts.phone.href}>{contacts.phone.label}</a> : null}
        </div>
      </div>

      <div className={styles.bottom}>
        <p>© {currentYear} Лучезарная Долина</p>
        <p>
          Данный интернет-сайт носит информационный характер и не является публичной офертой.
        </p>
      </div>
    </footer>
  );
}
